const fns = [];
export const destroyFns = fns;
export function destroyAll() {
    while (fns.length) {
        const destroy = fns.pop();
        if (destroy && typeof destroy === 'function') {
            destroy();
        }
    }
}
